import React from 'react';
import PropTypes from 'prop-types';
import DrivenPlateDetails from './driven-plate-details';
import TorsionDamperDetails from './torsion-damper-details';
import PressurePlateDetails from './pressure-plate-details';
import KitDetails from './kit-details';
import BearingDetails from './bearing-details';

function ProductDetails({ product }) {
  if (!product) {
    return '';
  }
  if (product.type === 'DrivenPlate') {
    return (
      <DrivenPlateDetails product={product} />
    )
  }
  if (product.type === 'TorsionDamper') {
    return (
      <TorsionDamperDetails product={product} />
    )
  }
  if (product.type === 'PressurePlate') {
    return (
      <PressurePlateDetails product={product} />
    )
  }
  if (product.type === 'Kit') {
    return (
      <KitDetails product={product} />
    )
  }
  if (product.type === 'Bearing') {
    return (
      <BearingDetails product={product} />
    )
  }
  throw new Error('Type not recognized');
}

ProductDetails.defaultProps = {};
ProductDetails.propTypes = {
  product: PropTypes.shape({
    type: PropTypes.oneOf(['PressurePlate', 'TorsionDamper', 'DrivenPlate', 'Bearing', 'Kit'])
  })
};

export default ProductDetails;
